import { AHIcon, AHTodoCategoryIcon, TodoPrioIcon } from "arkh";
import { useFragment, graphql } from "react-relay";
import { TeamFeatureBarTodoCategoryItem_todoCategoryTeam$key } from "./__generated__/TeamFeatureBarTodoCategoryItem_todoCategoryTeam.graphql";
import { TeamFeatureItem } from "./TeamFeatureItem";

import { IconLayout } from "./IconLayout";

export function TeamFeatureBarTodoCategoryItem(props: {
  todoCategoryTeam: TeamFeatureBarTodoCategoryItem_todoCategoryTeam$key;
  onPress: (categoryId: string, categoryName: string) => void;
  profileIndicator: React.ReactNode;

  isGrid: boolean;
}) {
  const todoCategoryTeam = useFragment(
    graphql`
      fragment TeamFeatureBarTodoCategoryItem_todoCategoryTeam on TodoCategoryTeam {
        id
        notResolvedCount
        todoActiveAssignedCount(employeeId: $employeeId)
        hasExpiredTodos
        todoHighestPrio
        category {
          id
          title
          icon
        }
      }
    `,
    props.todoCategoryTeam
  );

  const hasAssigned = todoCategoryTeam.todoActiveAssignedCount > 0;

  const icons = [];
  if (hasAssigned) {
    icons.push(props.profileIndicator);
  }
  if (todoCategoryTeam.todoHighestPrio) {
    icons.push(<TodoPrioIcon priority={todoCategoryTeam.todoHighestPrio} />);
  }
  if (todoCategoryTeam.hasExpiredTodos) {
    icons.push(<AHIcon type="flag" size="medium" color="negative" />);
  }

  return (
    <TeamFeatureItem
      isGrid={props.isGrid}
      icon={
        <AHTodoCategoryIcon icon={todoCategoryTeam.category?.icon ?? "Check"} />
      }
      title={todoCategoryTeam.category?.title ?? ""}
      onPress={() =>
        props.onPress(
          todoCategoryTeam.category?.id ?? "",
          todoCategoryTeam.category?.title ?? ""
        )
      }
      right={<IconLayout icons={icons} />}
      count={todoCategoryTeam.notResolvedCount}
    />
  );
}
